import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

const gcpResourcesTab = EntityContentBlueprint.make({
  name: 'gcp-resources',
  params: {
    path: '/gcp',
    title: 'GCP',
    filter: entity => {
      const annotations = entity.metadata?.annotations ?? {};
      return (
        !!annotations['google.com/batch-label'] ||
        !!annotations['google.com/compute-label'] ||
        !!annotations['google.com/gcs-buckets']
      );
    },
    loader: () =>
      import('./GcpResourcesContent').then(m => <m.GcpResourcesContent />),
  },
});

export const gcpResourcesModule = createFrontendModule({
  pluginId: 'app',
  extensions: [gcpResourcesTab],
});
